import { FormSectionCollapsible, Col, FormGroup, Label } from 'twyne-new.ui';

function Card({ title, children, defaultOpen = true, ...props }) {
  return <>
    <FormSectionCollapsible
      defaultOpen={defaultOpen}
      border
      triggerClass='py-2 px-4 twy-subtle-neutral'
      contentClass='p-4'
      titleClass='text-base pr-2'
      title={title}
      {...props}
    >
      <div className='flex flex-col gap-2'>
        {children}
      </div>
    </FormSectionCollapsible>
  </>
}

function Property({ label, value }) {
  return <Col size='2'>
    <FormGroup>
      <Label>{label}</Label>
      <div className='twy-text-base-accent wrap-break-words'>{value || '--'}</div>
    </FormGroup>
  </Col>
}

export { Card, Property }

